<template>
  <div class="slider-container bb-h28 bb-lg-h25 bb-fs0 bb-w100vw bb-of-hidden relative">
    <div class="slider relative bb-hcr mt3 center"
      :class="transitionClass"
      :style="'width:' + sliderWidth">
      <div class="slider-inner" swipe-added="false">
        <div v-for="n in (flatMode ? 1 : 3)"
          class="slides-container relative inline-block bb-fs0 bb-perspective100"
          :class="[ transitionClass, Math.ceil((activeSlideIndex +
          (sliderData.length & 2 !== 0 ? 1 : 0)) / sliderData.length) === n ? 'bb-zindex1' : '' ]"
          :style="'right:' + calcSliderPosition(0) + ';perspective-origin:'+calcPerspectiveOrigin(n)+'%'">
          <div class="evenifier-slide slide inline-block align-top"
            :class="[ slideWidthClass, transitionClass ]"
            :index="0"
            :style="'transform: rotateY(' + calcRotationDeg(0) +'deg)'"
            @mouseenter="slideHovered"
            v-if="n === 1 && sliderData.length % 2 === 0 && !flatMode">
            <div class="relative bb-pointer
              bb-bgs-cover bb-bgp-center bb-bg-no-repeat bb-shadow1"
              :class="slideHeightClass"
              :style="'background-image:' +
              getBgImageUrlString(sliderData[sliderData.length - 1].value._id,imageName)">
            </div>
            <div class="mt2 bb-fs1 left-align">
              {{ sliderData[sliderData.length - 1].doc.synopsis }}
            </div>
            <div class="mt2 bb-fs1p5 left-align"
            v-if="sliderData[sliderData.length - 1].doc.video_length">
              {{ $utilities.displayTime(sliderData[sliderData.length - 1].doc.video_length /
                1000) }}
            </div>
          </div>
          <div v-for="(data, dataIndex) in sliderData"
            class="slide inline-block relative align-top"
            :class="[ slideWidthClass, transitionClass, flatMode ? slidePaddingClass : '',
            calcIndex(dataIndex, n) > activeSlideIndex ? 'bb-zindex0' : 'bb-zindex1' ]"
            :index="calcIndex(dataIndex, n)"
            :style="'transform: rotateY(' + calcRotationDeg(calcIndex(dataIndex, n)) + 'deg)'"
            @mouseenter="slideHovered">
            <div class="relative bb-pointer
              bb-bgs-cover bb-bgp-center bb-bg-no-repeat bb-shadow1"
              :class="slideHeightClass"
              :style="'background-image:' + getBgImageUrlString(data.value._id, imageName)"
              @click="slidePosterClicked">
            </div>
            <div class="mt2 bb-ff2 bb-fs1 bb-fc1 left-align">
              {{ data.doc.synopsis }}
            </div>
            <div class="mt2 bb-ff2 bb-fs1pt13 bb-fc2 left-align"
            v-if="data.doc.video_length">
              {{ $utilities.displayTime(data.doc.video_length / 1000) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="slider-indicators bb-fs0 center bb-mt1pt7 sm-hide md-hide
      lg-hide xl-hide absolute bottom-0 mb1 left-0 right-0">
      <div v-for="n in sliderData.length"
        class="inline-block circle border-box bb-w0pt75 bb-h0pt75 bb-brd3"
        :class="[ n > 1 ? 'ml1' : '', n - 1 === activeSlideIndex % sliderData.length ? 'bb-bc2' : '',
        sliderData.length < 2 ? 'display-none' : '']"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'slider',
  props: ['sliderData'],
  data () {
    return {
      sliderWidth: 0,
      activeSlideIndex: -1,
      flatMode: false, // flat mode is when theres no need for sliding functionality
      canSlide: true,
      canRegulate: false,
      slideWidthClass: 'bb-w28', // determines individual slide width
      slideHeightClass: 'bb-h16', // determines individual slide height
      slidePaddingClass: 'px2', // determines individual slide padding in flatmode
      transitionClass: '', // determines slide transition
      tempTransitionClass: 'bb-transition1',
      direction: 'none',
      imageName: '/502-featured.jpg'
    }
  },
  methods: {
    calculateSliderWidth: function () {
      if (this.sliderData.length === 1) {
        // increase size of poster if comingSoon has one slide
        this.slideWidthClass = 'bb-w29'
        this.slideHeightClass = 'bb-h18pt77'
      }

      var slideWidth = this.$utilities.getWidthOfClass('.' + this.slideWidthClass)
      var slidePadding = this.$utilities.getClassStyle('.' + this.slidePaddingClass).paddingLeft
      // takes into account spacing between slides only in flatmode
      slidePadding = this.$utilities.parseStyleString(slidePadding)
      if (((slideWidth.value + (slidePadding.value * 2)) *
        parseFloat(getComputedStyle(document.documentElement).fontSize))
        * this.sliderData.length < document.body.clientWidth) { // flatmode if slides fit in screen
        this.flatMode = true

        this.sliderWidth = ((slideWidth.value + (slidePadding.value * 2)) * this.sliderData.length) +
          slideWidth.unit

        this.activeSlideIndex = Math.floor(this.sliderData.length / 2)
      } else { // slider mode if slides dont fit in screen
        this.flatMode = this.sliderData.length === 1 // if slides > 1 then enter slider mode

        this.sliderWidth = (slideWidth.value *
          ((this.sliderData.length * 3) + (this.sliderData.length % 2 === 0 ? 1 : 0))) + slideWidth.unit

        this.activeSlideIndex = Math.floor(this.sliderData.length / 2) + this.sliderData.length
      }
      this.sliderRenderFinished()
    },
    resized: function () { // recalculates slider width on screen resize to change mode if needed
      this.calculateSliderWidth()
    },
    slideHovered: function (e) {
      var slide = this.mapToParentSlide(e.target)
      var index = parseInt(slide.getAttribute('index'))

      this.slideToNextSlide(index)
    },
    sliderSwiped: function (el, direction) {
      if (direction === 'left') {
        this.slideToNextSlide(this.activeSlideIndex + 1)
      } else if (direction === 'right') {
        this.slideToNextSlide(this.activeSlideIndex - 1)
      }
    },
    slideToNextSlide: function (newIndex) {
      if (this.canSlide) {
        if (this.transitionClass === '') { // re-add animation if removed during regulation
          this.transitionClass = this.tempTransitionClass
        }

        // determine direction of slide to help regulate
        if (this.activeSlideIndex > newIndex) {
          this.direction = 'left'
        } else if (this.activeSlideIndex < newIndex) {
          this.direction = 'right'
        } else {
          this.direction = 'none'
        }

        this.activeSlideIndex = newIndex

        this.canRegulate = true
      }
    },
    mapToParentSlide: function (target) {
      // find closest parent slide
      if (this.isSlide(target)) {
        return target
      } else {
        return this.mapToParentSlide(target.parentNode)
      }
    },
    isSlide: function (target) {
      return this.$utilities.hasClass(target, 'slide')
    },
    getSlideByIndex: function (i) {
      var slides = document.getElementsByClassName('slide')
      for (var index in slides) {
        if (typeof slides[index] === 'object' && slides[index].getAttribute('index') === String(i)) {
          return slides[index]
        }
      }
    },
    calcIndex: function(i, n) { //calculates and returns the proper index for every slide
      return i + ((n - 1) * this.sliderData.length) +
        (this.sliderData.length % 2 === 0 && !this.flatMode ? 1 : 0)
    },
    calcRotationDeg: function (index) { // new rotation degree for each slide on hover
      // for 3d effect
      var degree = 35
      return this.flatMode ? 0 : degree * (this.activeSlideIndex - index)
    },
    calcPerspectiveOrigin: function (n) { // new perspective origin for each slide on hover
      // for 3d effect
      var perspective = 50 / this.sliderData.length
      return (perspective + ((this.activeSlideIndex - 1 - this.sliderData.length +
        (this.sliderData.length % 2 === 0 ? 0 : 1)) * (100 / this.sliderData.length))) -
        ((n - 2) * 100)
    },
    calcSliderPosition: function (any) { // new position for each slide on hover
      var slideWidth = this.$utilities.getWidthOfClass('.' + this.slideWidthClass)
      var position = -(slideWidth.value * (Math.floor(this.sliderData.length / 2) -
        (this.activeSlideIndex - this.sliderData.length)))
      position = this.flatMode ? 0 : position // resets position to center if flatmode
      return position + slideWidth.unit
    },
    regulate: function () {
      // if index goes out of bounds from center indexes, then re-center
      if (((this.activeSlideIndex <
        (this.sliderData.length + (this.sliderData.length % 2 === 0 ? 1 : 0))) ||
        (this.activeSlideIndex >= (this.sliderData.length * 2) +
        (this.sliderData.length % 2 === 0 ? 1 : 0))) && this.canRegulate) {
        this.canRegulate = false
        this.canSlide = false
        var self = this
        setTimeout(function () {
          self.canSlide = true
          // removes animation for seemless re-centering
          self.transitionClass = ''
          var offset = (self.direction === 'left') ? self.sliderData.length :
            (self.direction === 'right') ? -self.sliderData.length : 0
          self.activeSlideIndex = self.activeSlideIndex + offset
        }, this.$utilities.getTransitionDurationOfClass('.' + this.transitionClass) * 1000)
      }
    },
    slidePosterClicked: function () {
      this.$emit('emitSlidePosterClicked')
    },
    getImageUrl: function (uri, name) {
      return this.$store.getters.getImageUrl(uri, name)
    },
    getBgImageUrlString: function (uri, name) {
      return 'url("' + this.getImageUrl(uri, name) + '")'
    },
    sliderRenderFinished: function () {
      this.$emit('sliderRenderFinished')
    }
  },
  watch: {
    'activeSlideIndex': 'regulate',
    'sliderData': 'resized'
  },
  mounted () {
    this.calculateSliderWidth()

    var sliderInners = document.getElementsByClassName('slider-inner')
    for (var i in sliderInners) { // there are currently 2 sliders, add swipe feature to both
      if (typeof sliderInners[i] === 'object' &&
        sliderInners[i].getAttribute('swipe-added') === 'false') {
        this.$utilities.detectSwipe(sliderInners[i], this.sliderSwiped)
        sliderInners[i].setAttribute('swipe-added', 'true')
      }
    }

  },
  created () {
    window.addEventListener('resize', this.resized)
  },
  destroyed () {
    window.removeEventListener('resize', this.resized)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/slider.vue